/**
 * @copyright 2019 @ DigiNet
 * @author VINHLE
 * @create 2019/01/30 11:00
 * @update 2019/01/20 03:46
 * @example Form W17F1000
 */

import { NumberBox } from "devextreme-react";
// import 'devextreme/dist/css/dx.common.css';
// import 'devextreme/dist/css/dx.light.css';
import notify from "devextreme/ui/notify";
import { Button, Col, Row, Typography } from 'diginet-core-ui/components';
import { makeStyles } from "diginet-core-ui/theme";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";
import * as w17f0010Actions from "../../../actions/w17f0010-actions";
import Config from "../../../config";
import TimeFormatField from '../time-input/time-input';

const useStyles = makeStyles(theme => ({
    boardInfo: {
        margin: theme.spacing([2, 3, 0, 3]),
        padding: theme.spacing([3, 6]),
        display: 'flex',
        flexDirection: 'column',
        border: `1px solid ${theme.colors.line.category}`
    },
    title: {
        marginTop: '-22px',
        padding: theme.spacing([0, 5]),
        marginLeft: theme.spacing(5),
        background: theme.colors.white,
        width: 'fit-content'
    }
}));
class CustomerSetting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            numDateChange: 0,
            CheckInTime: null,
            condition: '',
            TimeOfAttendance: '',
            TimeOfAttendanceOut: ''
        };
        this.timeFormatRef = null;
    }

    componentDidMount() {
        this.handleLoadData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.mode !== this.props.mode) this.handleLoadData();
    }

    handleLoadData() {
        const { mode } = this.props;
        if (mode === 'customerSetting') this.loadCboCondition();
        else if (mode === 'DMSSetting') this.loadDMSSettingData();
    };

    loadCboCondition() {
        const param = {
            select: 'ConditionID,ConditionName'
        }
        this.props.w17f0010Actions.dataCondition(param, (error, data) => {
            if (error) {
                let errorCode = error.code || null;
                let message = "";
                switch (errorCode) {
                    case "US004":
                        message = Config.lang("Tai_khoan_dang_nhap_hoac_mat_khau_khong_dung");
                        break;
                    case "T1009E004":
                        //Du lieu rong
                        break;
                    default:
                        message = error.message || Config.lang("Loi_chua_xac_dinh");
                        Config.popup.show('INFO', message);
                        break;
                }
                return false;
            }
            if (data) {
                if (data.length > 0) {
                    this.loadCondition();

                }
                this.loadNumDateChange()
            }
        })
    }

    loadCondition() {
        const param = {
            TransFieldID: 'ConditionID',
            TransTypeID: 'WarningSaleFail',
        }
        this.props.w17f0010Actions.loadCustomerSetting(param, 'condition', (error, data) => {
            if (error) {
                let errorCode = error.code || null;
                let message = "";
                switch (errorCode) {
                    case "US004":
                        message = Config.lang("CRM_Tai_khoan_dang_nhap_hoac_mat_khau_khong_dung");
                        break;
                    case "T1009E004":
                        //Du lieu rong
                        break;
                    default:
                        message = error.message || Config.lang("CRM_Loi_chua_xac_dinh");
                        Config.popup.show('INFO', message);
                        break;
                }
                this.setState({ isSubmit: false, message: message, loading: false });
                return false;
            }
            if (data) {
                this.setState({
                    condition: data.StringValue,
                    loading: false
                })
            }
        });
    }

    loadDMSSettingData() {
        this.setState({ loading: true });
        this.props.w17f0010Actions.loadDMSSettingData((error, data) => {
            this.setState({ loading: false });
            if (error) {
                Config.popup.show('INFO', error?.message || Config.lang("Loi_chua_xac_dinh"));
                return false;
            } else if (data) {
                this.setState({ ...data });
            }
        });
    }

    loadNumDateChange() {
        const param = {
            TransFieldID: 'NumDateChange',
            TransTypeID: 'WarningSaleFail'
        }
        this.props.w17f0010Actions.loadCustomerSetting(param, 'numDateChange', (error, data) => {
            if (error) {
                let errorCode = error.code || null;
                let message = "";
                switch (errorCode) {
                    case "US004":
                        message = Config.lang("Tai_khoan_dang_nhap_hoac_mat_khau_khong_dung");
                        break;
                    case "T1009E004":
                        //Du lieu rong
                        break;
                    default:
                        message = error.message || Config.lang("Loi_chua_xac_dinh");
                        Config.popup.show('INFO', message);
                        break;
                }
                this.setState({ isSubmit: false, message: message, loading: false });
                return false;
            }
            if (data) {
                this.setState({
                    numDateChange: data.NumValue
                })
            }
        });
    }

    formatTime(value = '') { // Format str giờ định dạng có dấu (:)
        let result = value;
        if (Object.hasOwn(this.timeFormatRef ?? {}, 'timeFormatInput')) result = this.timeFormatRef.timeFormatInput(value) || '';
        return result; // return string (hh:mm or hh:mm:ss)
    };

    onSave() {
        const { mode } = this.props;
        if (mode === 'customerSetting') {
            const params = {
                TransTypeID: 'WarningSaleFail',
                TransFieldID: 'ConditionID',
                StringValue: this.state.condition,
            }
            this.props.w17f0010Actions.saveCustomerSetting(params, (error, data) => {
                if (error) {
                    Config.popup.show('INFO', Config.lang('Co_loi_khi_luu'));
                    return false;
                } else if (data) {
                    const paramNum = {
                        TransTypeID: 'WarningSaleFail',
                        TransFieldID: 'NumDateChange',
                        NumValue: this.state.numDateChange,
                    }
                    this.props.w17f0010Actions.saveCustomerSetting(paramNum, (error) => {
                        if (error) {
                            Config.popup.show('INFO', Config.lang('Co_loi_khi_luu'));
                            return false;
                        } else if (data) {
                            notify(Config.lang('Luu_thanh_cong'), 'success', 2000);
                        }
                    })
                }
            })
        } else if (mode === 'DMSSetting') {
            const { CheckInTime, TimeOfAttendance } = this.state;
            if (Object.hasOwn(this.timeFormatRef || {}, 'isValidTime') && !this.timeFormatRef.isValidTime(TimeOfAttendance, true)) {
                Config.popup.show('INFO', `${Config.lang('Gio_khong_dung_dinh_dang')}. ${Config.lang('Ban_vui_long_kiem_tra_lai')}`);
                return;
            }
            const params = {
                CheckInTime,
                TimeOfAttendance
            }
            this.props.w17f0010Actions.saveDMSSetting(params, (error, data) => {
                if (error) {
                    Config.popup.show('INFO', Config.lang('Co_loi_khi_luu'));
                    return false;
                } else if (data) {
                    notify(Config.lang('Luu_thanh_cong'), 'success', 2000);
                }
            })
        }
    }

    tabInfoRender = () => {
        const classes = useStyles();
        const { iPer, dataCondition, mode } = this.props;
        const { numDateChange, CheckInTime, TimeOfAttendance, TimeOfAttendanceOut } = this.state;
        let title = '';
        let content = null;
        switch (mode) {
            case 'customerSetting':
                title = Config.lang('Thiet_lap_khach_hang_chung');
                content = <>
                    <Col xs={12} md={12} sm={2} lg={2}>
                        <Typography type={'h4'}>{Config.lang('Dieu_kien')}</Typography>
                    </Col>
                    <Col xs={12} md={12} sm={4} lg={4}>
                        <select className={'form-control'} value={this.state.condition} onChange={(e) => {
                            this.setState({ condition: e.target.value })
                        }}>
                            <option value={''} />
                            {dataCondition && dataCondition.map((value, index) => {
                                return (
                                    <option key={index} value={value.ConditionID}>{value.ConditionName}</option>
                                )
                            })}
                        </select>
                    </Col>
                    <Col sx={{ display: { xs: 'none', sm: 'none', md: 'block', lg: 'block' } }} xs={0} sm={0} md={6} lg={6} />
                    <Col xs={12} md={12} sm={2} lg={2}>
                        <Typography type={'h4'}>{Config.lang('Sau_so_ngay')}</Typography>
                    </Col>
                    <Col xs={12} md={12} sm={4} lg={4}>
                        <NumberBox
                            value={numDateChange}
                            mode={"number"}
                            onValueChanged={(e) => {
                                this.setState({
                                    numDateChange: !e.value ? 0 : e.value
                                })
                            }}
                        />
                    </Col>
                </>
                break;
            case 'DMSSetting':
                title = Config.lang('Thiet_lap_DMS');
                content = <>
                    <Col xs={12} md={12} sm={2} lg={2}>
                        <Typography type={'h4'}>{Config.lang('Gio_cham_cong')}</Typography>
                    </Col>
                    <Col xs={12} md={12} sm={4} lg={4}>
                        <TimeFormatField
                            ref={ref => this.timeFormatRef = ref}
                            placeholder={Config.lang('Gio_vao')}
                            value={TimeOfAttendance}
                            onChange={(e) => this.setState({ TimeOfAttendance: e || '' })}
                        />
                    </Col>
                    <Col xs={12} md={12} sm={4} lg={4}>
                        <TimeFormatField
                            ref={ref => this.timeFormatRef = ref}
                            placeholder={Config.lang('Gio_ra')}
                            value={TimeOfAttendanceOut}
                            onChange={(e) => this.setState({ TimeOfAttendanceOut: e || '' })}
                        />
                    </Col>
                    <Col sx={{ display: { xs: 'none', sm: 'none', md: 'block', lg: 'block' } }} xs={0} sm={0} md={2} lg={2} />
                    <Col xs={12} md={12} sm={2} lg={2}>
                        <Typography type={'h4'}>{Config.lang('Thoi_gian_checkIn')} (m)</Typography>
                    </Col>
                    <Col xs={12} md={12} sm={4} lg={4}>
                        <NumberBox
                            value={CheckInTime}
                            mode={"number"}
                            onValueChanged={(e) => this.setState({ CheckInTime: e.value ?? null })}
                        />
                    </Col>
                </>
                break;
            default:
                break;
        }

        return (
            <Row>
                <Col xs={12}><div className={classes.title}><Typography>{title}</Typography></div></Col>
                {content}
                <Col xs={12} md={12} lg={12} sm={12}>
                    <Button
                        size={"small"}
                        color={'info'}
                        startIcon={'Save'}
                        className={'pull-right'}
                        label={Config.lang('Luu')}
                        labelProps={{ style: { color: 'initial' } }}
                        disabled={!iPer || iPer < 3}
                        onClick={() => this.onSave()}
                    />
                </Col>
            </Row>
        )
    };

    render() {
        if (Config.isEmpty(this.props.mode)) return '';
        const classes = useStyles();
        return (
            <div className={classes.boardInfo}>{this.tabInfoRender()}</div>
        );
    }
}

CustomerSetting.propTypes = {
    iPer: PropTypes.number,
    mode: PropTypes.string,
};

export default connect(state => ({
    dataCondition: state.w17f0010.dataCondition,
}), (dispatch) => ({
    w17f0010Actions: bindActionCreators(w17f0010Actions, dispatch)
}))(CustomerSetting);
